/**
 * @function mergeSubmenus
 * @async
 * @param { Array } tabs
 * @param { Array } subtabs
 * @returns { Promise<Array> } tabs
 */
function mergeSubmenus(tabs, subtabs) {
	for (let i = 0; i < subtabs.length; i++) {
		for (let j = 0; j < tabs.length; j++) {
			if (subtabs[i].name === tabs[j].name) {
				tabs[j]['subtabs'] = subtabs[i].subtabs;
			}
		}
	}

	return tabs;
}

export default mergeSubmenus;
